import React from 'react'

import SuccessIcon from '../../../../../assets/form-result-success.svg'

import { Wrapper, Title, SubTitle } from './ResultBlock.style'

const pickErrorMessageByCode = errorCode => {
  switch (errorCode) {
    case 'INVALID_DOUBLON':
      return 'Une demande existe déjà pour ce contact. Merci de contacter Nextories pour plus d’informations.'
    case 'INVALID_MISSING_INFO':
    case 'NVALID_SYNTAX':
      return 'Malheureusement, votre demande n’a pas pu aboutir. Merci de réessayer plus tard'
    default:
      return 'Error'
  }
}

const ResultBlock = ({ error = false, errorCode = '' }) =>
  error ? (
    <Wrapper>
      <Title>{pickErrorMessageByCode(errorCode)}</Title>
    </Wrapper>
  ) : (
    <Wrapper>
      <img src={SuccessIcon} alt="Success" />
      <Title>
        Merci,
        <br />
        votre demande de devis de déménageurs professionnels
        <br />a bien été envoyée.
      </Title>
      <SubTitle>Un conseiller Nextories vous contactera prochainement par téléphone.</SubTitle>
    </Wrapper>
  )

export default ResultBlock
